<template>

  <b-row
    v-if="showDateInput"
    class="datepicker-row"
  >
    <b-col
      v-if="!dataLoad"
      cols="12"
      sm="6"
      class="datepicker-col"
    >
      <div>
        <b-form-datepicker
          id="datepicker-full-width-expired-from"
          v-model="LocalFromDate"
          today-button
          reset-button
          menu-class="w-100 datepicker-menu-responsive"
          calendar-width="100%"
          class="datepicker-full-width"
          @input="handleFormDataChange"
        />
      </div>
    </b-col>
    <b-col
      v-if="!dataLoad"
      cols="12"
      sm="6"
      class="datepicker-col"
    >
      <div>
        <b-form-datepicker
          id="datepicker-full-width-expired-to"
          v-model="LocalToDate"
          today-button
          reset-button
          menu-class="w-100 datepicker-menu-responsive"
          calendar-width="100%"
          class="datepicker-full-width"
          @input="handleFormDataChange"
        />
      </div>
    </b-col>
  </b-row>
</template>

<script>

export default {
  props: {
    showDateInput: {
      type: Boolean,
      default: false,
    },
    dataLoad: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      LocalFromDate: null || this.$route.query.expired_from,
      LocalToDate: null || this.$route.query.expired_to,
    }
  },
  methods: {
    handleFormDataChange() {
      this.$router.push({
        query: { ...this.$route.query, expired_from: this.LocalFromDate, expired_to: this.LocalToDate },
      })
    },
  },
}
</script>

  <style lang="scss" scoped>
  .datepicker-full-width {
    button {
      color: #0081f2 !important;
    }
  }

  .datepicker-row {
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }

  .datepicker-col {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    margin-bottom: 0.35rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
  </style>
